module.exports = __webpack_public_path__ + "media/applicants/newyorktimes-42fe5a4d.png";